import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { transactionService } from '../services';

export function useTransactions(year, month) {
  return useQuery({
    queryKey: ['transactions', year, month],
    queryFn: () => transactionService.list(year, month),
  });
}

export function useYearlyTransactions(year, enabled = true) {
  return useQuery({
    queryKey: ['transactions', year],
    queryFn: () => transactionService.listYear(year),
    enabled,
  });
}

export function useTransactionYears() {
  return useQuery({
    queryKey: ['transactionYears'],
    queryFn: () => transactionService.availableYears(),
    staleTime: 5 * 60 * 1000,
  });
}

export function useAddTransaction() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: transactionService.create,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['transactions'] });
      queryClient.invalidateQueries({ queryKey: ['dashboard'] });
    },
  });
}

export function useDeleteTransaction() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: transactionService.delete,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['transactions'] });
    },
  });
}
